import { PropType } from 'vue'
import { SectionResult } from '../types'

export const RESPONSE_CONTENT_PROPS = {
  sections: {
    type: Array as PropType<SectionResult[]>,
    required: true,
  },
  patientId: {
    type: String as PropType<string>,
    required: true,
  },
  loading: {
    type: Boolean,
    required: true,
  },
} as const
